import React from 'react';
import styles from './UserWalletWrapper.module.scss';
import UserWalletBalance from '../UserWalletBalance/UserWalletBalance';
import UserWalletTransactionHistory from '../UserWalletTransactionHistory/UserWalletTransactionHistory';
import {
	MeddiAccountType,
	useMeddiAccountsQuery,
} from '../../../../graphql/graphql';
import UserWalletRedeemCode from '../UserWalletRedeemCode/UserWalletRedeemCode';
import useTranslation from '../../../../Hooks/useTranslation';
import Text from '../../../BaseModule/Components/Text';
import useLoading from '../../../Base/Hook/useLoading';

interface Props {
	userId: string;
}

const UserWalletWrapper: React.FC<Props> = ({ userId }) => {
	const { RenderLoading } = useLoading(true);
	const { data, isLoading, isFetching, refetch } = useMeddiAccountsQuery({
		where: { userId },
	});

	const { t } = useTranslation();

	const ACCOUNT_LABELS: Record<MeddiAccountType, string> = {
		[MeddiAccountType.Default]:
			t('component.userWalletWrapper.account.meddiCredits') ?? '',
		[MeddiAccountType.Company]:
			t('component.userWalletWrapper.account.vipCredits') ?? '',
	};

	if (isLoading || isFetching) {
		return <RenderLoading />;
	}

	return (
		<div className={styles.wrapper}>
			<div className={styles.topCards}>
				{data?.meddiAccounts?.data?.map(account => {
					if (typeof account?.balance === 'number' && account?.type) {
						return (
							<UserWalletBalance
								title={ACCOUNT_LABELS[account.type]}
								balance={account.balance}
								isPurchasable={account.type === MeddiAccountType.Default}
							/>
						);
					}
				})}
			</div>
			<UserWalletRedeemCode onRedeemCode={refetch} />
			<Text
				tx='component.userWalletWrapper.transactionHistory'
				className={styles.title}
			/>
			<UserWalletTransactionHistory userId={userId} />
		</div>
	);
};

export default UserWalletWrapper;
